export default __webpack_public_path__ + "static/media/Bahar-Sarlak-resume.2c0ec89c.pdf";